import type { SVGProps } from "react"
import * as React from "react"

const SvgGooglePlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    width={20}
    height={20}
    {...props}
  >
    <path
      d="M11.576 5.56a2515 2515 0 0 0-5.79-3.118 1.86 1.86 0 0 0-1.28-.214 1.54 1.54 0 0 0-.915.61c-.235.328-.341.735-.341 1.18V19.84c0 .388.076.797.288 1.14.228.369.6.636 1.083.68a.8.8 0 0 0 .17-.003c.35.001.682-.111.99-.279l.11-.059.615-.333a5749 5749 0 0 0 12.265-6.648l.85-.463 1.085-.587.073-.038.026-.014.018-.01c.321-.168.765-.528.893-1.074a1.26 1.26 0 0 0-.149-.942c-.17-.286-.437-.5-.741-.661l-.008-.004a498 498 0 0 1-3.917-2.125 1 1 0 0 0-.128-.055l-1.523-.823zm2.131 5.29L8.311 5.505l2.553 1.377 3.673 1.982.753.406zM4.75 19.784V4.086l7.896 7.824zm10.026-7.877 1.907-1.896c1.787.975 3.152 1.716 3.441 1.866l.022.012-.018.01c-.155.08-.974.525-2.147 1.163l-1.309.712zm-6.367 6.346 5.304-5.287 1.581 1.557a5153 5153 0 0 1-6.885 3.73"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgGooglePlay
